import React from "react";

function UnAuthorized() {
  return (
    <div className="container">
      <h1>UnAuthorized</h1>
      <p>You are not authorized to access this page</p>
      <p>Please contact the administrator</p>
      <p>Or try again later</p>
    </div>
  );
}

export default UnAuthorized;
